import styled from 'styled-components'

const StepHeaderHeadlinesUi = styled.div`
  display: block;
  flex-basis: calc(80% - 30px);
`

export default StepHeaderHeadlinesUi
